declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../../../models/api_request_model';
import { SpinnerService } from '../../../../../../services/spinner.service';
import { AppData } from '../../../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest } from '../../../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../../../services/hcp.service';


import * as alertFunctions from '../../../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, SavePatientInfoRequest, PatientInfoByFormattedCodeController, UpdatePatientInfoRequest, SaveVendorInfoRequest, SaveMaterialDetailsInfoRequest, MaterialsListController, MaterialsListRequest, SaveMaterialToStoreInfoRequest, SaveNewServiceRequest, GenericProcPostRequest, S_Methods } from '../../../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../../../models/actor/actor';
import { ActorService } from '../../../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../../../models/master/mastermodel';
import { FDService } from '../../../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { NgbSearchProviderModal } from '../../../../ivf/ivfworkbench/searchprovider.modal';
import { NgbSearchPatientModal } from '../../../../follow up/counsellingregistry/modal/searchpatient.modal';
import { NgbCameraUploadModal } from './cameraupload.modal';

@Component({
  selector: 'ngbaddnewservice',
  templateUrl: './addnewservice.modal.html',
  styleUrls: ['./addnewservice.modal.scss']
})

export class NgbAddNewServiceModal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;

  searchTitle: string;
  public ApiResData: ApiResponseModel;
  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;
  DOB: NgbDateStruct;
  WeddingDate: NgbDateStruct;
  RegistrationVal: NgbDateStruct;
  VaildFrom: NgbDateStruct;
    ValidTo: NgbDateStruct;    
  public SelectedSource: string;
  public ProviderName: string;
  public ProviderCode: number;
    public ProviderNumber: string;
    public searchValue: string;
    public ActorCode2: number;
    public FacilityCode: number;
    MfgDate: NgbDateStruct;
    ExpDate: NgbDateStruct;
  public StaffNumber: string;
  public isRequesting: boolean = false;
  public ShowService: boolean = true;
    Todate = new Date();
    TodayDate = new Date();
  //public IsSelected: boolean;
  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
    private router: Router, private route: ActivatedRoute, private modalService: NgbModal, private hcpservice: HCPService, private parserFormatter: NgbDateParserFormatter,
    private tosterservice: NGXToastrService) { }
  ngOnInit() {
    this.ShowService = false;
    this.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.ActorCode2 = AppData.Instance().UserLoginDetails.ActorCode;
    this.MfgDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
    this.ExpDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
    this.CurrentSaveNewServiceRequest = new SaveNewServiceRequest();
    this.CurrentSaveNewServiceRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  }


  CurrentSaveNewServiceRequest = new SaveNewServiceRequest();
  AddService() {
    var saveReq = new SaveNewServiceRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 30050;
    saveReq.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    saveReq.UserName = AppData.Instance().UserLoginDetails.UserName;
    saveReq.ServiceName = this.CurrentSaveNewServiceRequest.ServiceName;
    saveReq.RevenueCategoryCode = this.CurrentSaveNewServiceRequest.RevenueCategoryCode;
    saveReq.Price = this.CurrentSaveNewServiceRequest.Price;
    //saveReq.IsPriceEditable = this.CurrentSaveNewServiceRequest.IsPriceEditable;
    saveReq.DepartmentCode = this.CurrentSaveNewServiceRequest.DepartmentCode;
    saveReq.ServiceCategoryCode = this.CurrentSaveNewServiceRequest.ServiceCategoryCode;
    saveReq.ServiceType = this.CurrentSaveNewServiceRequest.ServiceType;
    saveReq.ServicePoint = this.CurrentSaveNewServiceRequest.ServicePoint;
    //if (e.target.checked) {
    //  saveReq.IsPriceEditable = true;
    //}
    //else if (!e.target.checked) {
    //  saveReq.IsPriceEditable = false;
    //}
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 30050;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result[0].length > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.activeModal.close();
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
    MaterialGroupCode: number = 0;
    public MaterialGroupName: string;
    onAssignedToActorCodesurgeon2(event: any) {

        if (event != null) {
            this.MaterialGroupName = event;
        }

    }
  StoreCode: number = 0;
  public StoreName: string;
  onAssignedStores(event: any) {

    if (event != null) {
      this.StoreName = event;
    }

  }
    SupplierCode: number = 0;
    public SupplierName: string;
    onAssignedVendors(event: any) {

        if (event != null) {
            this.SupplierName = event;

        }

    }
  public SelectedFacilityCode: number;
  SelectedFacilityName: string;
  Branchdata(event: any) {

    if (event != null) {
      this.SelectedFacilityName = event;
    }

  }
  public ServiceCategoryCode: number;
  ServiceCategoryName: string;
  ServiceCategory(event: any) {

    if (event != null) {
      this.ServiceCategoryName = event;
    }

  }
  public DepartmentCode: number;
  DepartmentName: string;
  Department(event: any) {

    if (event != null) {
      this.DepartmentName = event;
    }

  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  onChange2(event: any) {
    this.SelectedSource = event;

  }

}
